module.exports = __webpack_public_path__ + "static/media/5DPO8.f1549736.jpg";